export default __webpack_public_path__ + "static/timeline1-a15f559d4f2b5913b8a3e4c8a367bf7d.png";